var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('JobbookingCreateForm',{attrs:{"isInitialLoading":_vm.isLoading,"initialDetailedJob":_vm.detailedJob}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }